<ion-header class="ion-no-border" [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="primary" (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="modern-header">
      <div class="app-title">{{ 'OTP.VERIFY' | translate }}</div>
      <div class="app-tagline">{{ 'OTP.ENTER_CODE' | translate }}</div>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-no-border modern-content">
  <div class="form-container">
    <ion-card class="otp-card modern-card">
      <ion-card-content class="card-content">
        <div class="otp-input-wrapper">
          <ng-otp-input #otpInput (onInputChange)="onOtpChange($event)" [config]="{
              length: 6,
              inputStyles: {
                'width': '40px',
                'height': '46px',
                'font-size': '22px',
                'font-weight': '600',
                'background-color': 'var(--ion-color-light)',
                'color': 'var(--ion-color-dark)',
                'border': '2px solid transparent',
                'border-radius': '12px',
                'margin': '0 4px',
                'transition': 'all 0.3s ease'
              }
            }">
          </ng-otp-input>
        </div>

        <div class="timer-section">
          <ion-icon name="time-outline" color="medium"></ion-icon>
          <span class="countdown">{{ countdown }} {{ 'OTP.SECONDS_REMAINING' | translate }}</span>
        </div>
      </ion-card-content>
    </ion-card>

    <div class="button-container">
      <ion-button class="submit-btn" shape="round" size="large" expand="block" [disabled]="!otp || otp.length !== 6"
        color="primary" (click)="verifyOtp()">
        <ng-container *ngIf="!approve2">
          <span>{{ 'OTP.CONTINUE' | translate }}</span>
          <ion-icon slot="end" name="arrow-forward-outline"></ion-icon>
        </ng-container>
        <ion-spinner *ngIf="approve2" name="crescent"></ion-spinner>
      </ion-button>

      <ion-button class="resend-btn" shape="round" fill="clear" size="default" expand="block" color="primary"
        (click)="resend()" [disabled]="countdown > 0">
        {{ 'OTP.RESEND' | translate }}
      </ion-button>
    </div>
  </div>
</ion-content>